import { render } from "./Index.vue?vue&type=template&id=2d6b9872"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Roles/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d6b9872"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d6b9872', __exports__)) {
    console.log('reload')
    api.reload('2d6b9872', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=2d6b9872", () => {
    console.log('re-render')
    api.rerender('2d6b9872', render)
  })

}


export default __exports__